import React, { useEffect, useRef, useState } from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import NoData from '@shared/components/noData'
import useWindowSize from '@shared/hooks/windowSize'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import CommonNav from '@shared/components/commonNav'
import { useRouter } from 'next/router'
import queryGraphql from '@shared/components/queryGraphql'
import { GET_MAJOR_SERIES_DATA_FIXTURE } from '@graphql/champions-trophy/champions'
import usePolling from '@shared/hooks/usePolling'

function ChampionMatches({ fixtureData = [], fixture = [], isMobile = false }) {
  const [width] = useWindowSize()
  const [isViewMore, setIsViewMore] = useState(false)
  const matchContainerRef = useRef(null)
  const router = useRouter()
  const { query } = router
  const [isUpcoming, setIsUpcoming] = useState(true)
  const [newFixtureData, setNewFixtureData] = useState(fixture)

  // function formatDate(timestamp) {
  //   const date = new Date(timestamp)
  //   const options = {
  //     month: 'short',
  //     day: 'numeric',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: true
  //   }
  //   return date.toLocaleString('en-US', options)
  // }

  function scrollToMatch() {
    const currentTime = Date.now()

    if (fixture?.length > 0) {
      const nearestMatch = fixture.reduce((nearest, match) => {
        const matchTime = new Date(match.dStartDate).getTime()
        const currentNearest = new Date(nearest.dStartDate).getTime()

        return Math.abs(matchTime - currentTime) < Math.abs(currentNearest - currentTime) ? match : nearest
      })

      setTimeout(() => {
        const element = document.getElementById(nearestMatch.dStartDate)
        if (element) {
          matchContainerRef.current.scrollTo({
            top: element.offsetTop - 440,
            behavior: 'smooth'
          })
        }
      }, 300)
    }
  }

  useEffect(() => {
    if (width > 767) {
      scrollToMatch()
    }
  }, [width])

  useEffect(() => {
    if (query.tab === 'result') {
      setIsUpcoming(false)
    } else {
      setIsUpcoming(true)
    }
    if (width < 767) {
      const element = document.getElementById('matchContainer')
      element.scrollIntoView()
    }
  }, [query.tab])

  const upComingMatches = newFixtureData?.filter(d => d?.sStatusStr === 'scheduled' || d?.sStatusStr === 'live')

  const pastMatches = newFixtureData?.filter(d => d?.sStatusStr === 'completed')

  const data =
    width > 767 ? newFixtureData : isUpcoming ? isViewMore ? upComingMatches : upComingMatches?.slice(0, 5) : isViewMore ? pastMatches : pastMatches?.slice(0, 5)

  async function pollingCallback() {
    try {
      const allData = await queryGraphql(GET_MAJOR_SERIES_DATA_FIXTURE, {
        input: { iSeriesId: '676e345596e5d419bbccc7eb' }
      })
      return allData?.data?.getMajorSeriesData?.aFixtures
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  usePolling(async () => {
    const data = await pollingCallback()
    setNewFixtureData(data)
  })
  return (
    <div className={styles.matchContainer}>
      <div className="d-flex justify-content-center align-items-center">
        <h1 id="matchContainer" className="text-center my-0">
          Champions Trophy 2025
        </h1>
      </div>
      {width < 767 && (
        <CommonNav
          items={[
            { navItem: 'Upcoming', url: '/champions-trophy-2025?tab=upcoming', active: isUpcoming },
            { navItem: 'Result', url: '/champions-trophy-2025?tab=result', active: !isUpcoming }
          ]}
          isMatch
        />
      )}
      <div className={`${styles.matches}`} ref={matchContainerRef}>
        {data?.length === 0 && (
          <div className="mb-4">
            <NoData title="Quiet now, but the action is just around the corner. Keep your gear ready!" />
          </div>
        )}
        {data?.length > 0 &&
          data?.map((fixture, i) => {
            if (!isMobile) {
              return (
                <>
                  <CustomLink href={`/${fixture?.oSeo?.sSlug}`}>
                    <a>
                      <div key={i} id={fixture?.dStartDate} className={`${styles.match} d-flex justify-content-between align-items-center`}>
                        <div className="d-flex flex-row align-items-center justify-content-start text-center w-100 gap-2">
                          <MyImage
                            src={
                              fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl ? getImgURL(fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl) : 'https://media.oneturf.news/team/thumbUrl/163399.png'
                            }
                            height={45}
                            width={45}
                          />
                          <div className="d-flex flex-column text-start">
                            <h6 className="my-0 mt-1">{fixture?.oTeamScoreA?.oTeam?.sAbbr || ''}</h6>
                            {fixture?.oTeamScoreA?.sScores && (
                              <span className={styles.score}>
                                {fixture?.oTeamScoreA?.sScores || ''} {`(${fixture?.oTeamScoreA?.sOvers || ''})`}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="d-flex flex-column text-center gap-1" style={{ width: '-webkit-fill-available' }}>
                          <span className={styles.status}>
                            {fixture?.sStatusStr === 'live' ? 'Live' : fixture?.sStatusStr === 'completed' ? 'Result' : fixture?.sStatusStr === 'Cancelled' ? 'Cancelled' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            }) || ''}
                          </span>
                          <span className={styles.place}>
                            {fixture?.sSubtitle} {`, ${fixture?.oVenue?.sLocation}`}
                          </span>
                        </div>
                        <div className="d-flex flex-row justify-content-end align-items-center text-center w-100 gap-2">
                          <div className="d-flex flex-column text-end">
                            <h6 className="my-0 mt-1">{fixture?.oTeamScoreB?.oTeam?.sAbbr || ''} </h6>
                            {fixture?.oTeamScoreB?.sScores && (
                              <span className={styles.score}>
                                {fixture?.oTeamScoreB?.sScores || ''} {`(${fixture?.oTeamScoreB?.sOvers || ''})`}
                              </span>
                            )}
                          </div>
                          <MyImage
                            src={
                              fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl ? getImgURL(fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl) : 'https://media.oneturf.news/team/thumbUrl/163399.png'
                            }
                            height={45}
                            width={45}
                          />
                        </div>
                      </div>
                    </a>
                  </CustomLink>
                </>
              )
            } else {
              return (
                <>
                  <div key={i} id={fixture?.dStartDate} className={`${styles.match} d-flex justify-content-between align-items-center`}>
                    <div className="d-flex flex-row align-items-center justify-content-start text-center w-100 gap-2">
                      <MyImage
                        src={
                          fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl ? getImgURL(fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl) : 'https://media.oneturf.news/team/thumbUrl/163399.png'
                        }
                        height={45}
                        width={45}
                      />
                      <div className="d-flex flex-column text-start">
                        <h6 className="my-0 mt-1">{fixture?.oTeamScoreA?.oTeam?.sAbbr || ''}</h6>
                        {fixture?.oTeamScoreA?.sScores && (
                          <span className={styles.score}>
                            {fixture?.oTeamScoreA?.sScores || ''} {`(${fixture?.oTeamScoreA?.sOvers || ''})`}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-column text-center gap-1" style={{ width: '-webkit-fill-available' }}>
                      {fixture?.sStatusStr === 'live' ? 'Live' : fixture?.sStatusStr === 'completed' ? 'Result' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      }) || ''}
                      <span className={styles.place}>
                        {fixture?.sSubtitle} {`, ${fixture?.oVenue?.sLocation}`}
                      </span>
                    </div>
                    <div className="d-flex flex-row justify-content-end align-items-center text-center w-100 gap-2">
                      <div className="d-flex flex-column text-end">
                        <h6 className="my-0 mt-1">{fixture?.oTeamScoreB?.oTeam?.sAbbr || ''} </h6>
                        {fixture?.oTeamScoreB?.sScores && (
                          <span className={styles.score}>
                            {fixture?.oTeamScoreB?.sScores || ''} {`(${fixture?.oTeamScoreB?.sOvers || ''})`}
                          </span>
                        )}
                      </div>
                      <MyImage
                        src={
                          fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl ? getImgURL(fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl) : 'https://media.oneturf.news/team/thumbUrl/163399.png'
                        }
                        height={45}
                        width={45}
                      />
                    </div>
                  </div>
                </>
              )
            }
          })}
      {width < 767 &&
  !isViewMore &&
  ((isUpcoming && upComingMatches?.length > 5) || (!isUpcoming && pastMatches?.length > 5)) && (
    <div className="w-100 d-flex mb-2 justify-content-center">
      <button className="theme-btn btn btn-primary" onClick={() => setIsViewMore(true)}>
        View More
      </button>
    </div>
      )}
      </div>
    </div>
  )
}

ChampionMatches.propTypes = {
  fixtureData: PropTypes.array,
  fixture: PropTypes.array,
  isMobile: PropTypes.bool
}

export default ChampionMatches
